<div id="{{imageInfoId}}">
  <div class="arm-image-container" *ngFor="let item of items">
    <div class="arm-image-info-image">
      <img src="{{item.image}}" />
    </div>
    <div class="arm-image-info-text">
      <span [title]="item.status" class="arm-image-status {{item.cssStatusClass}}">{{item.status}}</span>
      <span class="arm-image-title {{item.cssTitleClass}}">{{item.title}}</span>
    </div>
  </div>
</div>
